import React, { useState,Component,cloneElement } from 'react';
import {
    List, Edit, Datagrid, TextField, ReferenceField, Button, ReferenceInput, EditButton, GET_ONE,
    DateField, AutocompleteInput, SelectInput, Toolbar, SaveButton, SimpleForm, Filter, useRecordContext, useTranslate,
    DateInput,
    RefreshButton,
    TopToolbar,
    TextInput,
    useResourceContext,
    ShowButton,
    CreateButton,
} from 'react-admin';
import { Scrollbars } from 'react-custom-scrollbars';
import Modal from 'react-responsive-modal';
// import DateFnsUtils from '@date-io/date-fns';
// import MomentUtils from 'material-ui-pickers/utils/moment-utils';
// import mwLocale from "date-fns/locale/en_MW";
import myDataProvider from '../../src/myRestProvider';
// import { DateInput } from 'react-admin-date-inputs';
import noImage from './../images/combined-shape.svg';
import moment from 'moment';
import { CREATE } from 'ra-core';
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption,getLocalStorageKey } from "../common/common";
import { useLocation,Link } from 'react-router-dom';

import Swal from "sweetalert2";
import GetAppIcon from "@mui/icons-material/GetApp";



const PostPanel = (props) => {
    const [open, setOpen] = React.useState(false)

    const onOpenModal = () => {
        console.log('open', props);
        setOpen(true);
    };

    const onCloseModal = () => {
        console.log(open);
        setOpen(false);
    };

    // const fileData = props?.imageDetails && JSON.parse(props?.imageDetails);
    const fileData = props?.imageDetails;
    return (
        <div>
            {
                open ?
                    <div>
                        <a className="list-img" >
                            {fileData ?
                                <img onClick={onOpenModal} src={fileData} /> :
                                <img src={noImage} />
                            }
                        </a>
                        <Modal open={open} onClose={onCloseModal}>
                            <div className="image-large-view">
                                {fileData ?
                                    <img src={fileData} /> :
                                    <img src={noImage} />
                                }
                            </div>
                        </Modal>
                    </div>
                    :
                    <a className="list-img" >
                        {fileData ?
                            <img onClick={onOpenModal} src={fileData} /> :
                            <img src={noImage} />
                        }
                    </a>
            }
        </div>
    )
}


const  DownloadTag =(props)=> {
    // constructor(props) {
    //     super(props);
    //     this.state = {
    //         fileURL: null,
    //     };
    //     // console.log("props >>>>", props);
    // }
    const translate = useTranslate();


   const sendImageData = () => {
        console.log("props >>>>", props);
        const fileData = JSON.parse(props.fileDetails);
        console.log('fileData', fileData.file_id);

        myDataProvider(CREATE, '/proof_of_payment/download_file', { data: { file_id: fileData.file_id } })
            .then(json => {
                if (json.data.status === 'success') {
                    window.open(json.data?.file_url, '_blank');
                }
            })
            .catch(error => console.log('error', error));
    }
    
        return (
            <div className="download-button" onClick={sendImageData}>{translate('resources.proof_of_payments.fields.download')}</div>

        )
    

}

const StatusField = ({ source }) => {
    const record = useRecordContext();
    return (
        <span>{record[source] === null ? '-' : record[source] ? 'Yes' : 'No'}</span>
    )
}

const selectInputStyle = {
    width: 200,
};

const PostFilter = (props) => {
    const proofOfPaymentForm = getLocalStorageKey('proof_of_payment_form');
    const showOrderNumber = proofOfPaymentForm && proofOfPaymentForm.order_number.show;

    return (
        <Filter {...props}>
            {/* <DateInput source="created_at" 
            // label="Uploaded date from" 
            /> */}
            <DateInput source="date_from"/>
            <DateInput source="date_to"/>
            <TextInput source="first_name" />
            <TextInput source="last_name" />
            {/* <TextInput source="ship_to_sap_number" label="Ship To ID" /> */}
            <TextInput source="mobile" />
            <TextInput source="email" />
            <TextInput source="business_name" />
            <TextInput source='business_address'/>
            <SelectInput
                source="is_clickit_user"
                choices={[
                    { id: true, name: "True" },
                    { id: false, name: "False" },
                ]}
            />
        </Filter>
    )
}

const styles = {
    image: {
        height: 50,
        width: 50,
    },
}
const CreateDownloadButton = () => {
    const record = useRecordContext();

    return (<Button
    >
        <div>
            <DownloadTag fileDetails={record?.file_url_data}></DownloadTag>
            {/* <a className="download-button" href={record.file_url} target = '_blank'>Download</a> */}
        </div>
    </Button>)
}

const EditButtonField = () => {
    const record = useRecordContext();
    if (!record || record.is_clickit_user){
        return <Button
            component={Link}
            to={{
                pathname: '/users/' + record.user_id + '/show',
            }}
        >
            <span>View user</span>
        </Button>
    }else {
        return <EditButton source="edit" />;
    }
};  

const ImageShow = () => {
    const record = useRecordContext();
    console.log('records', record);

    return (
        <div>
            <PostPanel imageDetails={record.profile_image_data}></PostPanel>
        </div>)
}


const ListActions = (props) => {
    const location = useLocation();
    const resource = useResourceContext();
    const [customFilterUrl, setCustomFilterUrl] = useState(location.search);

    const callExport = (e) => {
      const options = CommonHeaderOption();
      const apiUrl = RUN_TIME_API_ENDPOINT;
      e.preventDefault();
      console.log("...", location.pathname, `${apiUrl}/${resource}_csv`);
      options.method = "GET";
      let _url = location.pathname.split("?");
      if (_url.length > 1 && _url[1] !== "") {
        console.log("params found");
  
        setCustomFilterUrl(_url[1], () => {
          fetch(`${apiUrl}/${resource}_csv?${customFilterUrl}`, options)
            .then((res) => {
              return res.json();
            })
            .then((jsonD) => {
              console.log("json= inside callback", jsonD.data);
              const msg = jsonD.data ? jsonD.data[0].message : "";
              Swal.fire({
                html: msg,
                icon: "success",
              });
              //   this.setState({ modalShow: true});
              //   this.setState({ modalMsg: msg});
            });
        });
        // this.setState({ customFilterUrl: _url[1] }, () => {
        //   fetch(
        //     `${apiUrl}/${this.props.resource}_csv?${this.state.customFilterUrl}`,
        //     options
        //   )
        //     .then((res) => {
        //       return res.json();
        //     })
        //     .then((jsonD) => {
        //       console.log("json= inside callback", jsonD.data);
        //       const msg = jsonD.data ? jsonD.data[0].message : "";
        //       Swal.fire({
        //         html: msg,
        //         icon: "success",
        //       });
        //       //   this.setState({ modalShow: true});
        //       //   this.setState({ modalMsg: msg});
        //     });
        // });
      } else {
        setCustomFilterUrl(location.search);
        fetch(`${apiUrl}/${resource}_csv?${location.search}`, options)
          .then((res) => {
            return res.json();
          })
          .then((jsonD) => {
            console.log("json= inside callback", jsonD.data);
            const msg = jsonD.data ? jsonD.data[0].message : "";
            Swal.fire({
              html: msg,
              icon: "success",
            });
            // this.setState({ modalShow: true});
            // this.setState({ modalMsg: msg});
          });
      }
    };
  
  
    const {
      filterValues,
      total,
      maxResults,
      currentSort,
      exporter,
      permanentFilter,
      showFilter,
      displayedFilters,
      filters,
      basePath,
    } = props;
    const csvResource = resource + "_csv";
    const translate = useTranslate()
    return (
      <>
        <TopToolbar>
          {filters &&
            cloneElement(filters, {
              resource,
              showFilter,
              displayedFilters,
              filterValues,
              context: "button",
            })}
          <RefreshButton />
          <div>
            <button
                className="export-button"
                onClick={(e) => callExport(e)}
                disabled={total === 0}
                sort={currentSort}
                filter={{ ...filterValues, ...permanentFilter }}
            >
                {<GetAppIcon />}
                <span>{translate("resources.users.fields.export")}</span>
            </button>
          </div>
        </TopToolbar>
      </>
    );
  }


const UserSignUpList = props => {
    const proofOfPaymentForm = getLocalStorageKey('proof_of_payment_form');
    const showOrderNumber = proofOfPaymentForm && proofOfPaymentForm.order_number.show;
    const translate = useTranslate();

    const CustomDateTimeField = ({ source }) => {
        const record = useRecordContext();
        const date = record[source] ? new Date(record[source]) : null;
        const formattedDate = date ? date.toLocaleDateString('en-GB') : '';
        const formattedTime = date ? date.toLocaleTimeString() : '';
      
        return (
          <span>
            {formattedDate}, {formattedTime}
          </span>
        );
      };
      

    return (
        <Scrollbars className="scroll-container">
            <List {...props} filters={<PostFilter />} actions={<ListActions />} sort={{ field: 'created_at', order: 'DESC' }} title={translate('resources.users.fields.clickit_user')}  exporter={false}>
                <Datagrid bulkActionButtons={false}>
                    <CustomDateTimeField source="created_at" showTime />
                    <TextField source="first_name" />
                    <TextField source="last_name" />
                    <TextField source='email' />
                    <TextField source='mobile' />
                    <TextField source="business_name" />
                    <TextField source='business_address'/>
                    {/* <StatusField source="status" /> */}
                    <EditButtonField />
                    <ImageShow source="profile_image_data" label="Profile Image" className={styles.image} />
                    <ShowButton />
                    {/* <CreateDownloadButton source="download" /> */}
                </Datagrid>
            </List>
        </Scrollbars>
    );
}

export default UserSignUpList;